<template>
<v-card
    :class="{'max_width': !fluid}"
    style="margin: auto;"
    v-if="payment != null && payment.state == 'open'"
>
    <v-card-title>
    <v-icon
        style="margin-right: 10px"
    >
        mdi-bank
    </v-icon>
        {{ payment_title }}
    </v-card-title>

    <v-card-text>
        <a 
            href="#" 
            style="position: relative; top: -15px"
            v-if="accept_credit"
            v-on:click="$emit('swich-to-pay-by-credit')"
        >
            Pay using credit / debit card instead
        </a>

        <v-row dense>
        <v-col>
            <v-select
                label="Account type"
                v-model="account_type"
                :items="account_types"
                outlined
                dense
                v-on:change="onInput"
            />
        </v-col>
        </v-row>

        <v-row dense>
        <v-col>
            <v-text-field
            label="Routing number"
            v-model="routing_number"
            outlined
            dense
            v-on:input="updateRoutingNumber"
            :hint="bank_name"
            persistent-hint
            autocomplete="off"
            />
        </v-col>
        </v-row>

        <v-row dense>
        <v-col>
            <v-text-field
            label="Account number"
            v-model="account_number"
            outlined
            dense
            autocomplete="off"
            v-on:input="onInput"
            />
        </v-col>

        <v-col>
            <v-text-field
            label="Confirm account number"
            v-model="confirm_account_number"
            outlined
            dense
            autocomplete="off"
            v-on:input="onInput"
            />
        </v-col>

        </v-row>

        <v-row dense>
            <v-text-field
                label="Account holder's name"
                v-model="account_holder_name"
                outlined
                dense
                autocomplete="off"
                v-on:input="onInput"
            />
        </v-row>

        <v-row 
            v-if="show_email" 
            dense
        >
            <v-text-field
                label="Email Address"
                v-model="email_address"
                outlined
                dense
                autocomplete="off"
                v-on:input="onInput"
            />
        </v-row>

        <v-row
            v-if="show_phone" 
            dense
        >
            <v-text-field
                label="Phone Number"
                v-model="phone_number"
                outlined
                dense
                v-on:input="onInput"
            />
        </v-row>

        <v-row
            v-if="payment.request.age_verification_requirement == 'checkbox'"
            dense
        >
            <v-col>
                <v-checkbox
                    :label="'By checking the box, you affirm that you are over the age of '+min_age_in_years+'.'"
                    v-model="age_verification_checked"
                    v-on:change="onInput"
                />
            </v-col>
        </v-row>

        <v-row
            v-if="payment.request.age_verification_requirement == 'birthdate'"
            dense
        >
            <v-col>
                <v-text-field
                    label="Date of Birth"
                    hint="MM/DD/YYYY - e.g. 2/8/1981 for Feb 8th 1981"
                    validate-on-blur
                    v-model="age_verification_birthdate"
                    autocomplete="off"
                    v-on:input="onInput"
                />
            </v-col>
        </v-row>

        <v-row
            v-if="show_pay_button"
        >
            <v-col>
                <v-btn
                    style="width: 100%;"
                    class="white--text"
                    color="#5D647C"
                    v-on:click="onPay"
                >
                    {{payment_text}}
                </v-btn>

            </v-col>
        </v-row>

        
    </v-card-text>

</v-card>
</template>

<script>
const validate = require('@/js/validate.js');
const _ = require('lodash');
const E164 = require('@/js/E164.js');

export default {
    
    props: {
        payment: {
            type: Object,
            default: function() { return null; }
        },

        fluid: {
            type: Boolean,
            default: function() { return false; }
        },

        show_pay_button: {
            type: Boolean,
            default: function() { return true; }
        },
    },

    data() {
        return {
            account_type: 'personal-checking',
            routing_number: null,
            account_number: null,
            confirm_account_number: null,
            account_holder_name: null,
            bank_name: null,


            age_verification_checked: false,
            age_verification_birthdate: null,
            email_address: null,
            phone_number: null,

            account_types: [
                {'text' : 'Personal checking', 'value' : 'personal-checking' },
                {'text' : 'Personal savings', 'value' : 'personal-savings' },
                {'text' : 'Business checking', 'value' : 'business-checking' },
                {'text' : 'Business savings', 'value' : 'business-savings' }
            ],
        }
    },

    methods: {

        nullToBlank(value)
        {
            if ( value == null ) return '';
            return value.trim();
        },

        onlyDigits(value)
        {
            value = this.nullToBlank(value);
            return value.replace(/\D/g, "");
        },

        expirationMonth(value)
        {
            let strs = value.split("/");
            if ( strs.length == 0 ) return null;

            value = this.onlyDigits(strs[0]);
            if ( value.length == 1 ) value = "0"+value;
            if ( value.length < 2 ) return null;


            if ( value == '01' ) return 'JANUARY';
            if ( value == '02' ) return 'FEBRUARY';
            if ( value == '03' ) return 'MARCH';
            if ( value == '04' ) return 'APRIL';
            if ( value == '05' ) return 'MAY';
            if ( value == '06' ) return 'JUNE';
            if ( value == '07' ) return 'JULY';
            if ( value == '08' ) return 'AUGUST';
            if ( value == '09' ) return 'SEPTEMBER';
            if ( value == '10' ) return 'OCTOBER';
            if ( value == '11' ) return 'NOVEMBER';
            if ( value == '12' ) return 'DECEMBER';

            return null;
        },

        expirationMonthNum(value)
        {
            let strs = value.split("/");
            if ( strs.length == 0 ) return null;
            value = this.onlyDigits(strs[0]);

            return parseInt(value);
        },


        expirationYear(value)
        {
            let strs = value.split("/");
            if ( strs.length < 2 ) return null;

            value = this.onlyDigits(strs[1]);

            if ( value.length == 2 )
            {
                let year = 2000+parseInt(value);
                return year;
            }
            else if ( value.length == 4 )
            {
                let year = parseInt(value);
                return year;
            }
        },

        updateRoutingNumber: _.debounce(function(){
            this.doUpdateRoutingNumber();
        }, 751),
        
        doUpdateRoutingNumber()
        {
            this.$rc.rest(
                'PUT: /api/v1/payments/lookup-routing-info',
            
                {
                    'routing_number': this.routing_number,
                },
            
                (data) => {
                    if ( data.code != 200 )
                        this.bank_name = null;

                    this.bank_name = data.customer_name;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );

            this.onInput();
        },

        onInput()
        {
            this.$emit('input', this.createPaymentInfo());
        },

        createPaymentInfo()
        {
            if ( this.bank_name == null ) return { 'error' : 'Routing number is invalid' };
            
            let account_number = this.onlyDigits(this.account_number);
            if ( account_number.length > 17 ) return { 'error' : 'Account number is invalid' };

            let routing_number = this.onlyDigits(this.routing_number);
            if ( routing_number.length != 9 ) return { 'error' : 'Routing number is invalid' };

            let confirm_account_number = this.onlyDigits(this.confirm_account_number);

            if ( account_number != confirm_account_number )
                return { 'error' : 'Please confirm your account number' };

            if ( account_number.length == 0 )
                return { 'error' : 'Please enter your accout number' };

            let account_holder_name = this.account_holder_name;

            if( account_holder_name == null || account_holder_name.trim().length == 0 )
                return { 'error' : 'Account holder name is invalid.' };

            let email_address = this.email_address;
            if ( email_address != null && (!email_address.includes('@') || !email_address.includes('.')) ) email_address = null;
            if ( this.payment.request.ex_field_email == 'required' && email_address == null ) return { 'error' : 'Valid email address required' };


            let phone_number = E164.createEndpointFromUSPhoneNumber(this.phone_number,null);
            if ( this.payment.request.ex_field_phone == 'required' && phone_number == null ) return { 'error' : 'Valid phone number required' };

            if ( this.payment.request.ex_field_phone == 'optional' && phone_number == null )
            {
                // check for non-blank but invalid phone number...
                if ( this.phone_number != null && this.phone_number.trim().length > 0 )
                {
                    return { 'error' : 'The phone number field must contain a valid phone number' };
                }
            }
            
            let age_verification_provided_text = null;
            let min_age_in_years = this.min_age_in_years;

            if ( this.payment.request.age_verification_requirement == 'checkbox' )
            {
                age_verification_provided_text = "checked";
            }

            if ( this.payment.request.age_verification_requirement == 'birthdate' )
            {
                age_verification_provided_text = this.age_verification_birthdate;
            }

            if ( this.payment.request.age_verification_requirement == 'checkbox' && !this.age_verification_checked )
            {
                return { 'error' : 'You must check the box affirming you are over the age of '+min_age_in_years+' to complete payment' };
            }

            if ( this.payment.request.age_verification_requirement == 'birthdate' && !validate.isOverAgeInYears(min_age_in_years,this.age_verification_birthdate, new Date()) )
            {
                return { 'error' : "You must be over the age of "+min_age_in_years+" to complete payment" };
            }

            return {
                'account_type': this.account_type,
                'bank_name' : this.bank_name,
                'routing_number': routing_number,
                'account_number' : account_number,
                'account_holder_name' : account_holder_name,
                'age_verification_provided_text' : age_verification_provided_text,
                'email_address': email_address,
                'phone_number': phone_number,
            };
        },

        onPay()
        {
            let payment_info = this.createPaymentInfo();

            if ( payment_info.error != null )
            {
                this.$rc.snackbar(payment_info.error,3500);
                return;
            }

            let min_age_in_years = this.min_age_in_years;

            if ( this.payment.request.age_verification_requirement == 'checkbox' && !this.age_verification_checked )
            {
                this.$rc.snackbar("You must check the box affirming you are over the age of "+min_age_in_years+" to complete payment",3500);
                return;
            }

            if ( this.payment.request.age_verification_requirement == 'birthdate'
                    && !validate.isOverAgeInYears(min_age_in_years,this.age_verification_birthdate, new Date()) )
            {
                this.$rc.snackbar("You must be over the age of "+min_age_in_years+" to complete payment",3500);
                return;
            }


            this.$emit('on-pay',payment_info);
        },

        validate()
        {
            let payment_info = this.createPaymentInfo();

            if ( payment_info.error != null )
            {
                return payment_info.error;
            }

            return null;
        },
    },

    computed: {
        payment_title() {
            if (this.payment.request.for_message != null && this.payment.request.for_message != '')
            {
                return 'Enter Banking Info';
            }
            else
            {
                return 'Pay by Bank Transfer (ACH)';
            }
        },

        payment_text() {
            if (this.payment.request.for_message != null && this.payment.request.for_message != '')
            {
                return 'Submit';
            }

            let ret = this.payment.request.amount_pretty_print;
            return 'Pay ' + ret;
        },

        pretty_print_amount_or_for_message() {
            if (this.payment.request.for_message != null && this.payment.request.for_message != '')
            {
                return this.payment.request.for_message;
            }

            let ret = this.payment.request.amount_pretty_print_without_currency;
            return ret;
        },

        cards_accepted() {
            let cards = [];

            let request = this.payment.request;

            if ( request.accept_visa ) cards.push('Visa');
            if ( request.accept_mastercard ) cards.push('Mastercard');
            if ( request.accept_amex ) cards.push('Amex');
            if ( request.accept_discover ) cards.push('Discover');

            let ret = '';

            for ( let i = 0; i < cards.length; i++ )
            {
                if ( ret.length != 0 && i == cards.length -1 && cards.length > 1 ) ret += ', and ';
                else if ( ret.length != 0 ) ret += ', ';
            
                ret += cards[i];
            }

            return ret +' cards accepted.';
        },

        min_age_in_years()
        {
            if ( this.payment == null ) return 21;
            if ( this.payment.request == null ) return 21;
            if ( this.payment.request.min_age_in_years == null ) return 21;

            return this.payment.request.min_age_in_years;
        },

        accept_ach()
        {
            return this.payment.request.accept_ach;
        },

        accept_credit()
        {
            return this.payment.request.accept_visa || this.payment.request.accept_mastercard || this.payment.request.accept_amex || this.payment.request.accept_discover;
        },

        show_email()
        {
            return this.payment.request.ex_field_email != 'do-not-show';
        },

        show_phone()
        {
            return this.payment.request.ex_field_phone != 'do-not-show';    
        },
    },

    watch: {
        expiration(newValue, oldValue) 
        {
            if ( newValue.trim().length == 2 )
            {
                 this.$nextTick(() => {
                   this.expiration = this.expiration + '/';
                });
            }

            if ( this.expiration.indexOf('//') != -1 )
            {
                this.$nextTick(() => {
                    let regex = /\/\//i;
                    this.expiration = this.expiration.replace(regex,'/');
                });
            }
        },

        routing_number(newValue, oldValue)
        {
            let val = ''+newValue;
            val = val.toLowerCase();

            if ( val == 'test' || val == 'fill' || val == 'sample' )
            {
                this.account_type = "personal-checking";
                this.routing_number = "122100024";
                this.account_number = "787870000";
                this.confirm_account_number = "787870000";
                this.account_holder_name = 'John Smith';
                this.email_address = this.show_email ? 'john.doe@gmail.com' : null;
                this.phone_number = this.show_phone ? '237-448-1938' : null;
                this.bank_name = "JPMORGAN CHASE";

                if ( this.payment.request.age_verification_requirement == 'birthdate' )
                {
                    this.age_verification_birthdate = '1/1/1970';
                }

                this.onInput();
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.max_width
{
    width: 550px;
}
</style>